var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "create-project-block container my-3" }, [
    _c("h5", { staticClass: "create-project-header ml-3" }, [
      _vm._v(
        "\n    " + _vm._s(_vm.$resourceString["common.addtobasket"]) + "\n  "
      )
    ]),
    _vm._v(" "),
    _c(
      "button",
      {
        staticClass: "wf-modal-button-close btn button-full",
        attrs: { type: "button" },
        on: { click: _vm.closeModal }
      },
      [
        _c("span", {
          staticClass: "png-icon png-icon-icons-symbols--k-txtclose",
          attrs: { "aria-label": "Close modal" }
        })
      ]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "ml-3 pl-1" }, [_c("step-three")], 1),
    _vm._v(" "),
    _c("div", { staticClass: "modal-footer border-0 mt-5 pr-0" }, [
      _c("div", { staticClass: "justify-content-between w-100  row" }, [
        _c(
          "button",
          {
            staticClass: "btn btn-outline-primary",
            on: { click: _vm.closeModal }
          },
          [
            _vm._v(
              "\n        " +
                _vm._s(
                  _vm.$resourceString["virtualtray.Savetray.Cancel.Button"]
                ) +
                "\n      "
            )
          ]
        ),
        _vm._v(" "),
        _c("span", [
          _c(
            "button",
            {
              staticClass: "btn btn-primary",
              attrs: {
                disabled:
                  _vm.getContentWizardData.step3.length == 0 ||
                  _vm.OrderSampleEnabled
              },
              on: {
                click: function($event) {
                  $event.preventDefault()
                  return _vm.addItemToCart($event)
                }
              }
            },
            [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.$resourceString["common.addtobasket"]) +
                  "\n        "
              )
            ]
          )
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }